<template>
  <section class="cockpit-panel schedule-panel">
    <div class="cockpit-title">农事调度</div>
    <ul>
      <li v-for="item in schedule" :key="item">
        <span></span>
        {{ item }}
      </li>
    </ul>
  </section>
</template>

<script setup>
const schedule = [
  "滴灌频次：傍晚1次",
  "追肥方案：少量氮钾追施",
  "通风时机：午后开启",
  "植保提醒：雨后排查",
];
</script>

<style lang="less" scoped>
@import "./rightPanelShared.less";

.schedule-panel {
  padding: 92px 48px 38px;
}

ul {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin: 0;
  padding: 0;
  list-style: none;
  text-align: left;
}

li {
  display: flex;
  align-items: center;
  color: #ffffff;
  font-size: 30px;
  font-weight: 900;
  line-height: 34px;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.24);
}

li span {
  width: 36px;
  height: 36px;
  margin-right: 24px;
  border: 2px solid rgba(93, 255, 241, 0.82);
  border-radius: 50%;
  box-shadow: inset 0 0 10px rgba(93, 255, 241, 0.18), 0 0 8px rgba(93, 255, 241, 0.35);
}

li span::after {
  content: "";
  display: block;
  width: 12px;
  height: 12px;
  margin: 11px auto;
  background: #65fff2;
  border-radius: 50%;
}
</style>
